/* eslint-disable */
import { GetterTree } from "vuex";
import { Progress } from "@/models/progress";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProgressState } from "@/types/progress";

const getters: GetterTree<ProgressState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Progress();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((progress) => Progress.toSelectItem(progress))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((progress) => {
          return progress.id == id;
        })
      : new Progress();
  },
};

export default getters;
